import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import {
  TextField,
  FormControl,
  FormLabel,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";

import { NationalityAutocomplete, CountryAutocomplete } from "../../../../../../../shared/Form";

import { applyCriteriaList } from "../../../../../enum/jobEnums";
import { CreateTalentJob } from "../../../../../types/createJobSchema";
import CreateJobAccordion from "../../../../../components/CreateJobAccordion";

const AdvancedTargeting = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.jobDetails" });
  const { t: tApplyingCriteria } = useTranslation("goHire", { keyPrefix: "enum.applyCriteria" });

  const {
    control,
    formState: { errors },
  } = useFormContext<CreateTalentJob>();

  const hasError = Boolean(errors.howManyHiresNeeded || errors.nationality || errors.talentProfessionalLocation);

  return (
    <CreateJobAccordion title={t("advancedTargeting")} error={hasError}>
      <Controller
        name="howManyHiresNeeded"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl fullWidth component="fieldset" error={!!error}>
            <FormLabel error={!!error}>{t("howManyHiresNeeded")}</FormLabel>
            <TextField {...field} fullWidth placeholder={t("ehowManyHiresNeeded")} error={!!error} />
            {error?.message && <FormHelperText error>{t(error.message)}</FormHelperText>}
          </FormControl>
        )}
      />
      <Controller
        name="nationality"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl fullWidth component="fieldset" error={!!error}>
            <FormLabel error={!!error}>{t("nationality")}</FormLabel>
            <NationalityAutocomplete {...field} error={!!error} multiple />
            {error?.message && <FormHelperText error>{t(error.message)}</FormHelperText>}
          </FormControl>
        )}
      />
      <Controller
        name="talentProfessionalLocation"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl fullWidth component="fieldset" error={!!error}>
            <FormLabel>{t("talentProfessionalLocation")}</FormLabel>
            <CountryAutocomplete {...field} error={!!error} multiple />
            {error?.message && <FormHelperText error>{t(error.message)}</FormHelperText>}
          </FormControl>
        )}
      />

      <FormControl fullWidth component="fieldset" variant="standard">
        <FormLabel component="legend">{t("whoCanApply")}</FormLabel>
        <FormGroup>
          {applyCriteriaList.map((option) => (
            <Controller
              key={option}
              name={option as keyof CreateTalentJob}
              control={control}
              render={({ field: { value, onChange, ...field } }) => (
                <FormControlLabel
                  control={<Checkbox checked={!!value} onChange={onChange} {...field} />}
                  label={tApplyingCriteria(option)}
                />
              )}
            />
          ))}
        </FormGroup>
      </FormControl>
    </CreateJobAccordion>
  );
};

export default AdvancedTargeting;
